// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/ColorPicker/styles.scss
// module id = 798
// module chunks = 0